export enum ErrorCode {
  Unknown = 1,
  NetworkError = 2,
  SslError = 3,
  NetworkRequestTimedOut = 21,
  AuthInvalidLoginCredentials = 51,
  AuthRefreshSessionInvalidParams = 52,
  AuthRefreshSessionRequestTooOld = 53,
  AuthRefreshSessionBadKey = 54,
  AuthNotLoggedIn = 55,
  AuthForcedLogOut = 56,
  AuthNoKioskForSerial = 57,
  AuthNoAccessCode = 58,
  AuthAccessCodeInsufficient = 59,
  AuthCustomerPasswordAlreadyUsed = 60,
  AuthInvalidCustomerToken = 61,
  AuthCustomerAccountNotVerified = 62,
  AuthCustomerAccountDisabled = 63,
  AuthCustomerAccountDeleted = 64,
  AuthMissingProvider = 65,
  AuthProviderRequired = 66,
  AuthIncorrectWebhookSignature = 67,
  AuthInvalidToken = 68,
  AuthInvalidApiToken = 69,
  AuthNoKiosk = 70,
  AuthMissingWebhookSignature = 71,
  AuthWebhookRejected = 72,
  AuthMfaInvalidOneTimePassword = 73,
  AuthMfaMissingOneTimePassword = 74,
  AuthMfaEmailTooManyRequests = 75,
  AuthInvalidKioskBuild = 76,
  AuthInvalidKioskOs = 77,
  AuthNoKioskDeviceStatus = 78,
  AuthRefundAuthInvalid = 79,
  AuthRefundAuthLocked = 80,
  UrlParamBadName = 101,
  UrlParamBadId = 102,
  UrlParamModelNotFound = 103,
  RequestParseError = 10001,
  MongoDBGenericError = 10002,
  MongoDBNetworkError = 10003,
  MongoDBDuplicateKeyError = 10004,
  RedisGenericError = 10021,
  IntegrationBadConfig = 10031,
  IntegrationBadResponse = 10032,
  IntegrationSyncNotPossible = 10033,
  IntegrationAlreadySyncing = 10034,
  IntegrationSyncFailed = 10035,
  DBElementFound = 10041,
  DBElementNotFound = 10042,
  DBModelInflationError = 10043,
  DBReadOnlyWriteBlocked = 10044,
  ExternalServiceAuthenticationError = 10051,
  ExternalServiceNetworkError = 10052,
  ExternalServiceNoAccess = 10053,
  ExternalServiceBadUserInput = 10054,
  ExternalServiceFailedImageDownload = 10055,
  ExternalServiceBadConfig = 10056,
  ExternalServiceRateLimit = 10057,
  ExternalService500 = 10058,
  ExternalServiceRequestRejected = 10059,
  RequestSchemaValidation = 10071,
  RequestDataValidation = 10072,
  RequestKeyDataMissing = 10073,
  RequestDataValidationDoNotNotifyEng = 10074,
  POSValidationBadResponseError = 10101,
  POSValidationItem86d = 10102,
  POSValidationPriceOption86d = 10103,
  POSValidationMod86d = 10104,
  POSValidationOrderTotalBelowMin = 10105,
  POSValidationGenericError = 10106,
  POSValidationTipsUnsupported = 10107,
  POSValidationRuleRequirementUnmet = 10108,
  POSValidationItemUnavailableAtThisTime = 10109,
  POSValidationItemUnavailableForOrderType = 10110,
  POSOrderingTurnedOff = 10111,
  POSKitchenClosingError = 10112,
  POSKitchenClosedError = 10113,
  POSCardDeclined = 10114,
  POSOrderRejected = 10116,
  POSOffline = 10117,
  POSSendingItem86d = 10118,
  POSSendingItemPriceOption86d = 10119,
  POSSendingMod86d = 10120,
  POSOrderNotCompleted = 10121,
  LoyaltyNoMatchingUser = 10122,
  LoyaltyAuthFailed = 10123,
  POSValidationItemMaxQuantityExceeded = 10124,
  POSValidationModMaxQuantityExceeded = 10125,
  POSValidationModMinQuantityUnmet = 10126,
  POSValidationAlcoholSaleRequiresFoodInCart = 10127,
  POSValidationItemMinQuantityUnmet = 10128,
  POSCouponAlreadyUsed = 10130,
  POSCouponUnmetParameters = 10131,
  POSCouponNotFound = 10132,
  POSCouponNotAccepted = 10133,
  POSCouponMinSpendUnmet = 10134,
  CouponIntegrationNotFound = 10135,
  AppliedCouponNotFound = 10136,
  POSDiscountNotAccepted = 10137,
  SmsNotifierSendError = 10138,
  SmsNotifierSendErrorLight = 10139,
  LoyaltyUserDisabled = 10140,
  LoyaltySignInAttemptsExceeded = 10141,
  StoredValueInquireAttemptsExceeded = 10142,
  LoyaltyUserMissingPhoneNumber = 10143,
  LoyaltyInvalidPhoneNumber = 10144,
  LoyaltyTokenInvalid = 10150,
  LoyaltyPaymentFailed = 10151,
  POSValidationInvalidTipAmount = 10152,
  // Terminal pre-send guard failures (see ErrorHelper.isPreSendValidationError).
  POSOrderPriceChanged = 10153,
  LoyaltyRewardNoLongerAvailable = 10155,
  OrderTotalBelowMin = 10201,
  OrderTotalAboveMax = 10202,
  OrderBeingProcessed = 10203,
  OrderAlreadySent = 10204,
  OrderUnclosed = 10205,
  OrderClosed = 10206,
  OrderUnclosable = 10207,
  OrderThrottleDollarValueExceeded = 10208,
  OrderThrottleCountExceeded = 10209,
  OrderNotCancelled = 10210,
  OrderPaidFor = 10211,
  OrderUnvalidated = 10212,
  OrderNotValidated = 10213,
  OrderNotValidatedOnI9n = 10214,
  OrderTooOldForValidation = 10215,
  OrderNotMostRecentOnKiosk = 10216,
  OrderRequestOutdated = 10217,
  OrderIncompatibleApiVersion = 10218,
  OrderNotRefunded = 10219,
  OrderAbandoned = 10220,
  OrderNotCreated = 10221,
  OrderValidationDiscarded = 10222,
  OrderValidationWhenClosed = 10301,
  FutureOrderValidationWhenNotEnabled = 10302,
  FutureOrderValidationWhenSlotExpired = 10303,
  FutureOrderValidationWhenSlotFarOut = 10304,
  FutureOrderValidationWhenSlotInvalid = 10305,
  FutureOrderValidationWhenSlotThrottled = 10306,
  OrderValidationOrderedItemsUnavailableInMenu = 10307,
  FutureOrderNoSlotsAvailable = 10308,
  FutureOrderValidationWhenLeadTimeExceedsSlot = 10309,
  OrderTipTooHigh = 10310,
  OrderValidationInvalidQuantity = 10311,
  OrderDonationTooHigh = 10312,
  OrderUpsertionRequiredModsAreAbsent = 10313,
  AsapOrderValidationWhenNotEnabled = 10314,
  OrderSurveyError = 10315,
  PaymentRemainingAmountOverpay = 10420,
  PaymentRemainingAmountMismatch = 10421,
  PaymentError = 10422,
  PaymentCancelled = 10423,
  PaymentEcommError = 10424,
  PaymentCaptureFailed = 10425,
  PaymentNotAllowed = 10426,
  PaymentInvalidCardOnFile = 10427,
  PaymentIdempotentUnsuccessfulSale = 10428,
  PaymentDemoOnLiveKiosk = 10429,
  PaymentTerminalNotFound = 10430,
  PaymentTerminalOffline = 10431,
  PaymentTerminalBusy = 10432,
  PaymentUserTimeout = 10433,
  PaymentCancelError = 10434,
  PaymentMerchantTimeout = 10435,
  PaymentTerminalDeleted = 10436,
  PaymentCardSchemeIdNotAccepted = 10437,
  PaymentActivationFailed = 10438,
  RefundSaleRecordMissing = 10440,
  RefundError = 10441,
  ApiPaymentNotFound = 10442,
  PaymentPreReadFailed = 10443,
  PaymentNativeResponseCorrection = 10444,
  PaymentNativeResponseException = 10445,
  RefundTransactionTooOld = 10446,
  RefundTransactionNotSettled = 10447,
  RefundTransactionSettled = 10448,
  PaymentMismatchedSaleAndRefund = 10449,
  LoyaltyBadResponseError = 10501,
  LoyaltyRewardCannotBeApplied = 10502,
  LoyaltyRewardCannotBeRemoved = 10503,
  LoyaltyCardIsInactive = 10504,
  LoyaltyCardCannotBeCharged = 10505,
  LoyaltyUserAlreadyExists = 10506,
  LoyaltyEnrollmentNotEnabled = 10507,
  LoyaltyNonUniqueIdentifier = 10508,
  LoyaltyNotSyncedWithPOS = 10509,
  LoyaltyRewardNotFoundOnOrder = 10510,
  LoyaltyRewardItemMissing = 10511,
  LoyaltyCardNoFunds = 10512,
  LoyaltyEmailAlreadyExists = 10513,
  CompCardAlreadyApplied = 10571,
  CompCardMissing = 10572,
  LoyaltyNotEnoughPoints = 10573,
  LoyaltyMinimumOrderAmountNotMet = 10574,
  CompCardTokenInvalid = 10575,
  LoyaltyRewardNotEnoughPoints = 10576,
  MenuFetcherEmptyMenu = 10601,
  MenuFetcherFutureEmptyMenu = 10602,
  MenuCacheOutdatedDuringBuild = 10603,
  ApiDisallowedOp = 10701,
  ApiNoRightToResource = 10702,
  ApiJobNotFound = 10703,
  ApiRateLimit = 10704,
  ApiDisabled = 10705,
  ApiStaleData = 10706,
  LocationMisconfigured = 10801,
  LocationFlashNotEnabled = 10802,
  LocationInvalidSearchQueryParams = 10803,
  LocationDeliveryAddressOutOfRange = 10804,
  LocationDeliveryUnavailable = 10805,
  LocationDeliveryAddressInvalidField = 10806,
  LocationDeliveryAddressMoreSpecific = 10807,
  FlashSessionTokenInvalid = 11000,
  FlashSessionTokenExpired = 11001,
  StoredValueCardNotFound = 11100,
  StoredValueCardInsufficientFunds = 11101,
  StoredValueCardDeclined = 11102,
  StoredValueCardDeactivated = 11103,
  StoredValueCardRestrictedTime = 11104,
  WebhookError = 11200,
  IncomingWebhooksDisabled = 11300,
  IncomingWebhooksRateLimited = 11301,
  RecommendationServiceError = 11400,
  CustomerTooManyFavorites = 12000,
  CustomerInvalidFavorite = 12001,
  LockReleaseFailed = 13001,
  LockedModel = 13002,
  ConcurrencyLockFailed = 13003,
  CannotModifyTipAfterPayment = 13004,
  CannotModifyLoyaltyAfterPayment = 13005,
  StoredValueCardNotAllowedForCashier = 13006,
  PayAtCashier = 13007,
  CashPaymentNotSupported = 13008,
  CannotModifyCouponAfterPayment = 13009,
  QueueOperationFailed = 14000,
  SendOrderUITimeoutWithPayment = 30000,
  ValidateOrderUITimeout = 30001,
  SendOrderUITimeoutWithoutPayment = 30002,
  OrgCustomDomainAlreadyRegistered = 40001,
  SystemHealthSubscriptionSend = 50001,
  SystemHealthSummariesUpdateFailed = 50002,
  MdmDeviceNotFound = 60001,
  MdmDeviceFailedToRestart = 60002,
  MdmDeviceRestartUnsupported = 60003,
  GarconBuildInvalid = 70001,
  GcnBuildInvalid = 70002,
  ChromeOSBuildInvalid = 70003,
  VitrineBuildInvalid = 70004,
  ExpoPrintAuthError = 80001,
  TcpClientError = 90001,
  FulfillmentOrderFailedToSend = 100001,
  FulfillmentIntegrationNotFound = 100002,
  MaxAlcoholicBeverageLimitPerOrderExceeded = 110001,
  MaxSpecialItemLimitPerOrderExceeded = 110002,
  KORTickUpdateFailed = 120001,
  MagicCopyDataAuditFailed = 130001,
  S3DeleteFailed = 140001,
  // Tagged on a Starbucks POS error whose signature matches a rejected Bearer
  // token (proxy ByteString 502 or Starbucks 401/403). The client uses this to
  // decide whether to invalidate the anonymous-token cache and retry once.
  StarbucksTokenRejected = 150001,
}
